import { forwardRef } from "react";
import { Avatar } from "../../../primitives/Avatar";
import { TableCell, TableCellProps } from "../TableCell/TableCell";

export type TableUserCellProps = {
  userName: string;
  avatarUrl?: string | null;
} & Pick<
  TableCellProps,
  "classNames" | "isFocused" | "isHoverable" | "isDisabled" | "onClick"
>;

export const TableUserCell = forwardRef<HTMLDivElement, TableUserCellProps>(
  (
    {
      classNames,
      userName,
      avatarUrl,
      isFocused,
      isHoverable,
      isDisabled,
      onClick,
    },
    ref
  ) => {
    return (
      <TableCell
        ref={ref}
        classNames={classNames}
        startContent={
          <Avatar username={userName} imageUrl={avatarUrl} size="sm" />
        }
        isFocused={isFocused}
        isHoverable={isHoverable}
        isDisabled={isDisabled}
        onClick={onClick}
      >
        <span className="truncate whitespace-nowrap">{userName}</span>
      </TableCell>
    );
  }
);
